export const BreakRuleTriggerType = Object.freeze({
    Less: 0,
    EqualOrLess: 1,
    Equal: 2,
    EqualOrMore: 3,
    More: 4
});

export const BreakRuleActionType = Object.freeze({
    Remove: 0,
    Add: 1
});
